// App.jsx - Correct (No changes needed after fixing index.jsx)

import React from "react";
import Routes from "./Routes";
import { Helmet } from "react-helmet-async"; 

function App() {
  // Your core identity statement
  const name = "Ebesoh Adrian: Developer, Tutor, and Tech Innovator";
  const mission = "Building impactful solutions and empowering the next generation of tech leaders.";
  
  return (
    <>
      {/* 🌟 SEO Defaults (Applies to all pages unless overridden) 🌟 */}
      {/* This <Helmet> now correctly finds the context from HelmetProvider in index.jsx */}
      <Helmet>
        {/* Default Title - CRITICAL for your name and keywords */}
        <title>{name}</title>
        
        {/* Default Meta Description - Use your mission statement */}
        <meta name="description" content={mission} />
        
        {/* Security and performance (Good practice) */}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      
      {/* Your routing component */}
      <Routes />
    </>
  );
}

export default App;

